"use client";

import { AbstractIntlMessages, NextIntlClientProvider } from "next-intl";

// https://next-intl-docs.vercel.app/docs/usage/configuration#nextintlclientprovider-non-serializable-props
export default function IntlProvider({
  messages,
  locale,
  showTranslationWarning,
  children,
}: {
  messages: AbstractIntlMessages;
  locale: string;
  showTranslationWarning?: boolean;
  children: React.ReactNode;
}) {
  return (
    <NextIntlClientProvider
      onError={(error) => {
        if (showTranslationWarning) console.warn(error);
      }}
      messages={messages}
      locale={locale}
    >
      {children}
    </NextIntlClientProvider>
  );
}
